import { useState } from "react";

// An "Are you sure?" box drawn by the page itself. Unlike window.confirm it can't be blocked or
// silently answered "Cancel" by the browser.
//   const [confirmBox, askConfirm] = useConfirm();
//   if (!(await askConfirm({ title, message, ok: "Send anyway" }))) return;
//   …and render {confirmBox} somewhere in the page.
export function useConfirm() {
  const [ask, setAsk] = useState(null);   // { title, message, ok, danger, resolve }
  const askConfirm = opts => new Promise(resolve => setAsk({ ...opts, resolve }));
  const answer = value => { ask?.resolve(value); setAsk(null); };
  const box = ask && (
    <div className="modal-ov" onClick={e => e.target === e.currentTarget && answer(false)}>
      <div className="modal" role="dialog" aria-modal="true" style={{ width: 460 }}>
        <div className="mh"><div className="mt">{ask.title || "Are you sure?"}</div><button className="mc" onClick={() => answer(false)}>✕</button></div>
        <div className="mb-m" style={{ whiteSpace: "pre-wrap", fontSize: 14 }}>{ask.message}</div>
        <div className="mf">
          <button className="btn btn-outline" onClick={() => answer(false)}>{ask.cancel || "Cancel"}</button>
          <button className={`btn ${ask.danger ? "btn-danger" : "btn-primary"}`} autoFocus onClick={() => answer(true)}>{ask.ok || "OK"}</button>
        </div>
      </div>
    </div>
  );
  return [box, askConfirm];
}
